export default function Autoridade() {
  return (
    <section className="relative py-24 bg-gradient-to-b from-black via-zinc-950 to-black">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-orange-500/20 blur-3xl"></div>
            <img
              src="https://static.readdy.ai/image/9423d153e6c1f4fd53c21de04be414e3/dd35623cc4b82c68291a1af7fdf34abe.png"
              alt="Tom Chagas"
              className="relative w-full h-full object-cover object-top rounded-lg shadow-2xl"
            />
          </div>

          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight">
              Criado por quem vive<br />
              <span className="text-orange-500">high gain de verdade</span>
            </h2>
            
            <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
              <p>
                <strong className="text-white font-bold">Tom Chagas</strong> é guitarrista de metal e hardcore há mais de <strong className="text-orange-500">25 anos</strong>, com experiência em estúdio, palco e gravações profissionais.
              </p>
              
              <p>
                Este pack foi desenvolvido com foco em <strong className="text-white">uso real</strong>, não em timbres bonitos sozinhos.
              </p>

              <div className="flex items-start gap-4 pt-4">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500/10 rounded-lg flex-shrink-0">
                  <i className="ri-medal-fill text-2xl text-orange-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">Experiência Real</h3>
                  <p className="text-gray-400">
                    Cada capture foi testada em situações reais de palco e estúdio, garantindo performance profissional.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
